module.exports = __webpack_public_path__ + "img/copy.2a032334.svg";